import React from "react";
import { FaWhatsapp, FaCommentAlt, FaEnvelope, FaTimes } from "react-icons/fa";

export default function ShareLinkModal({
  visible,
  onClose,
  onSend,
  setRecipient,
  recipient,
}) {
  if (!visible) return null;

  return (
    // overlay
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      {/* modal */}
      <div className="relative w-full max-w-md bg-white rounded-lg shadow-lg p-6">
        {/* close button */}
        <button
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
          onClick={onClose}
        >
          <FaTimes size={20} />
        </button>

        {/* header */}
        <h2 className="flex items-center text-2xl font-semibold mb-4 text-[#004276]">
          Share Link
          <FaWhatsapp className="ml-2 text-green-500" />
          <FaCommentAlt className="ml-2 text-blue-400" />
          <FaEnvelope className="ml-2 text-gray-700" />
        </h2>

        <hr className="border-gray-200 mb-6" />

        {/* controlled input */}
        <input
          type="text"
          placeholder="Enter Mobile"
          value={recipient}
          onChange={(e) => setRecipient(e.target.value)}
          className="w-full px-4 py-2 mb-6 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-300"
        />

        {/* actions */}
        <div className="flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
          >
            Cancel
          </button>
          <button
            onClick={onSend}
            disabled={!recipient.trim()}
            className={`px-4 py-2 text-white rounded  
              ${
                recipient.trim()
                  ? "bg-gradient-to-r from-[#004172] to-[#3cba84] hover:opacity-90"
                  : "bg-gray-300 cursor-not-allowed"
              }`}
          >
            Send
          </button>
        </div>
      </div>
    </div>
  );
}
